import {useMemo} from 'react'
import {EnhancementReportStat} from '../../../models/enhancement/enhancement-report-stats'
import {trendIncdicatorThemes} from '../../../shared/UI/TrendIndicatorCard/TrendStyles'

export interface EnhancementOverviewTile {
  name: string;
  hours: number;
  color: string;
  fontColor: string;
  borderColor: string;
}

export function useEnhancementOverview(reportData: EnhancementReportStat[]) {
  const overviewTiles = useMemo((): EnhancementOverviewTile[] => {
    const safeReportData = Array.isArray(reportData) ? reportData : []

    const totals = {
      onCall: 0,
      callOut: 0,
      overtime: 0,
      night: 0,
      weekend: 0,
      total: 0
    }

    safeReportData.forEach(stat => {
      const hours = typeof stat?.finalPaidHours === 'number' ? stat.finalPaidHours : 0
      const requestType = stat?.requestType || ''

      switch (requestType) {
        case 'On Call':
          totals.onCall += hours
          totals.total += hours
          break
        case 'Call Out':
          totals.callOut += hours
          totals.total += hours
          break
        case 'Overtime':
          totals.overtime += hours
          totals.total += hours
          break
        case 'Night':
          totals.night += hours
          totals.total += hours
          break
        case 'Weekend':
          totals.weekend += hours
          totals.total += hours
          break
        default:
          break
      }
    })
    
    return [
      {
        name: 'On Call',
        hours: totals.onCall,
        color: '#F1EEFF',
        fontColor: trendIncdicatorThemes.onCall.fontColor,
        borderColor: trendIncdicatorThemes.onCall.borderColor
      },
      {
        name: 'Call Out',
        hours: totals.callOut,
        color: '#FCEEF9',
        fontColor: trendIncdicatorThemes.callOut.fontColor,
        borderColor: trendIncdicatorThemes.callOut.borderColor
      },
      {
        name: 'Overtime',
        hours: totals.overtime,
        color: '#FFF2E0',
        fontColor: trendIncdicatorThemes.overtime.fontColor,
        borderColor: trendIncdicatorThemes.overtime.borderColor
      },
      {
        name: 'Night',
        hours: totals.night,
        color: '#EEEEF2',
        fontColor: trendIncdicatorThemes.night.fontColor,
        borderColor: trendIncdicatorThemes.night.borderColor
      },
      {
        name: 'Weekend',
        hours: totals.weekend,
        color: '#EAEAFF',
        fontColor: trendIncdicatorThemes.weekend.fontColor,
        borderColor: trendIncdicatorThemes.weekend.borderColor
      },
      {
        name: 'Total',
        hours: totals.total,
        color: '#FFFFFF',
        fontColor: trendIncdicatorThemes.total.fontColor,
        borderColor: trendIncdicatorThemes.total.borderColor
      }
    ]
  }, [reportData])

  return {overviewTiles}
}